export default {
  sm: `
  The basic concept for the brand mark of
  DATA CENTER GAK is "Chest of Data,"
  signifying the safe storage of valuable
  knowledge and information. 
  The monochromatic square without any
  colors added to it represents digital data
  itself, along with rational thought,
  power of judgment, and our commitment
  for safe storage.
  `,
  md: `
  The basic concept for the brand mark of
  DATA CENTER GAK is "Chest of Data,"
  signifying the safe storage of valuable
  knowledge and information. 
  The monochromatic square without any
  colors added to it represents digital data
  itself, along with rational thought, power of
  judgment, and our commitment for safe
  storage.
  `,
  lg: `
  The basic concept for the brand mark of DATA CENTER GAK is "Chest of Data,"
  signifying the safe storage of valuable knowledge and information. 
  The monochromatic square without any colors added to it represents digital data itself,
  along with rational thought, power of judgment, and our commitment for safe storage.
  `,
  xxl: `
  The basic concept for the brand mark of DATA CENTER GAK is "Chest of Data," signifying the safe storage of valuable
  knowledge and information. The monochromatic square without any colors added to it represents digital data itself,
  along with rational thought, power of judgment, and our commitment for safe storage.
  `,
};
